import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AssetsDashboard from './AssetsDashboard';
import AddAssetForm from './components/AddAssetForm';

const Assets = () => {
  return (
    <Routes>
      <Route index element={<AssetsDashboard />} />
      <Route path="new-asset" element={<AddAssetForm />} />
    </Routes>
  );
};

export default Assets;
